import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { FeatureFlagRoute } from '../components/feature-flag-route'
import FeatureFlags from '../config/feature-flags'
import { TablePageLoader } from '@/components/ui/page-loader'
import LazyRoute from '../components/LazyRoute'

const searchSchema = z.object({
  id: z.string().optional(),
})

export const Route = createFileRoute('/_protected/connections')({
  component: () => (
    <FeatureFlagRoute flag={FeatureFlags.WEBHOOK_ROUTING}>
      <LazyRoute
        loader={() => import('@/components/pages/Bridges')}
        fallback={<TablePageLoader />}
      />
    </FeatureFlagRoute>
  ),
  validateSearch: searchSchema,
})